module.exports = __webpack_public_path__ + "assets/img/center_icon00.898d5963.png";